export default __webpack_public_path__ + "static/media/new-user-sound.943c9e7f.mp3";